import { defineStore } from "pinia";
import {
  cursorEncoderById,
  cursorPagerStoreFactory,
} from "@/stores/factory/list-store-factory";
import { entityStoreFactory } from "@/stores/factory/entity-store-factory";
import {
  readReviewerExpenditurePage,
  readReviewerIncomePage,
} from "@/apis/reviewer";
import { ReviewerExpenditure, ReviewerIncome } from "@/types/reviewer";
import { useGlobalUser } from "@/stores/globalUser";
import { computed } from "vue";

export const useReviewer = defineStore("reviewer", () => {
  /** 金票花费记录状态维护 */
  const expenditureMap = entityStoreFactory<ReviewerExpenditure>("id");
  const { updateMap: updateQuestMap } = expenditureMap;
  const {
    dataList: expenditureList,
    initListIfAbsent: initExpenditureListIfAbsent,
    fetchNewerList: fetchNewerExpenditureList,
    fetchOlderList: fetchOlderExpenditureList,
  } = cursorPagerStoreFactory<ReviewerExpenditure>({
    entityStore: expenditureMap,
    fetch: async (cursor) => {
      const response = await readReviewerExpenditurePage({
        cursor,
        sort: { field: "id", order: "desc" },
      });
      updateQuestMap(response.page.data);
      return response.page.data;
    },
    cursorEncoder: cursorEncoderById,
  });
  /** 金票收入记录状态维护 */
  const incomeMap = entityStoreFactory<ReviewerIncome>("id");
  const { updateMap: updateIncomeMap } = incomeMap;
  const {
    dataList: incomeList,
    initListIfAbsent: initIncomeListIfAbsent,
    fetchNewerList: fetchNewerIncomeList,
    fetchOlderList: fetchOlderIncomeList,
  } = cursorPagerStoreFactory<ReviewerIncome>({
    entityStore: incomeMap,
    fetch: async (cursor) => {
      const response = await readReviewerIncomePage({
        cursor,
        sort: { field: "id", order: "desc" },
      });
      updateIncomeMap(response.page.data);
      return response.page.data;
    },
    cursorEncoder: cursorEncoderById,
  });

  return {
    /** 状态 */
    expenditureList,
    incomeList,
    /** 方法 */
    initExpenditureListIfAbsent,
    fetchNewerExpenditureList,
    fetchOlderExpenditureList,
    initIncomeListIfAbsent,
    fetchNewerIncomeList,
    fetchOlderIncomeList,
  };
});
